module.exports = __webpack_public_path__ + "img/Weihnachtsmarkt.a5ae5e48.svg";